import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import Http from './utils/request'
import WebSocket from './lib/websocket'
import VueSocketIo from 'vue-socket.io'
import { websocketUrl } from '../config/env'
Vue.use(
  new VueSocketIo({
    debug: false,
    connection: websocketUrl,
    vuex: {}
  })
)
Vue.use(WebSocket)
Vue.use(Http)
// 全局注册icon-svg
Vue.component('SvgIcon', SvgIcon)
Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
